import { render, staticRenderFns } from "./AdminDebitNoteButton.vue?vue&type=template&id=c4706270"
import script from "./AdminDebitNoteButton.vue?vue&type=script&lang=js"
export * from "./AdminDebitNoteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports